import { Counter, Flex, Shape } from 'front-commons/ds';
import { SimpleProductProps } from './interfaces';
import { Thumbnail } from './styles';
import { Typography, Icon } from 'hype-ds';
import { Constants } from 'front-commons/constants';

export default function SimpleProduct({ data }: SimpleProductProps) {
	const {
		data: allData,
		ean13,
		imageURL,
		quantity: currentQuantity,
		description,
		currentValue,
		currentDistributorName,
		sourceName,
	} = data;

	const stock = allData?.suggestedPromotion?.distributors.find(
		({ distributorName }) => distributorName === currentDistributorName,
	)?.stock;

	return (
		<Flex direction="column" gap="16px">
			<Flex direction="column" gap="0">
				<Typography.Label.L>Produto no seu carrinho</Typography.Label.L>

				<Flex alignItems="center" gap="8px">
					<Flex backgroundColor="--semantic-success-base" width="8px" height="8px" borderRadius="999px" />
					<Typography.Paragraph.S color="--text-secondary">{currentDistributorName}</Typography.Paragraph.S>
				</Flex>
			</Flex>

			<Flex
				gap="0px"
				border="1px solid"
				overflow="hidden"
				direction="column"
				borderColor="--border-disable"
				borderRadius="8px"
			>
				<Flex padding="16px" gap="16px">
					<Thumbnail>
						<img
							src={`${import.meta.env.VITE_STATIC_STORAGE_BASE}${imageURL}`}
							alt={`Imagem do produto ${description}`}
							onError={(el) => (el.currentTarget.src = Constants.FALLBACK_UNAVAILABLE_PRODUCT_IMAGE_SMALL)}
						/>
					</Thumbnail>

					<Flex direction="column" gap="8px" maxWidth="196px" width="100%">
						<Flex direction="column" gap="0" maxWidth={{ small: undefined, medium: '160px' }} height="100%">
							<Typography.Label.M>{description.toPascalCase()}</Typography.Label.M>
							<Flex gap="8px" alignItems="center">
								<Typography.Paragraph.XS color="--text-secondary">EAN {ean13}</Typography.Paragraph.XS>
								<Typography.Label.XS color="--text-link">{sourceName}</Typography.Label.XS>
							</Flex>
						</Flex>

						<Counter
							width="99px"
							height="37px"
							disabled
							quantity={currentQuantity}
							iconProps={{ size: '16px' }}
							hasPermission={false}
						/>
						{!!stock && (
							<Flex alignItems="center" gap="4px">
								<Shape shape="circle" color="--semantic-success-base" width="10px" height="10px" />
								<Typography.Label.XS color="--text-secondary">{Number(stock).handleWithMileDot()}</Typography.Label.XS>
								<Typography.Paragraph.S color="--text-secondary">un. em estoque</Typography.Paragraph.S>
							</Flex>
						)}

						{!stock && (
							<Flex alignItems="center" gap="4px">
								<Icon materialIconName="change_history" color="--semantic-error-text" size="16px" fill />
								<Typography.Paragraph.S color="--text-secondary">Estoque não informado</Typography.Paragraph.S>
							</Flex>
						)}
					</Flex>

					<Flex direction="column" gap="0" width="100%" maxWidth="108px" alignSelf="end">
						<Typography.Heading.XXS>{currentValue.toCurrency()}</Typography.Heading.XXS>
						<Typography.Label.XS color="--text-secondary">
							{(currentValue / currentQuantity).toCurrency()} un.
						</Typography.Label.XS>
					</Flex>
				</Flex>
				<Flex backgroundColor="--surface-primary" justifyContent="flex-end" padding="4px 16px" gap="4px">
					<Typography.Paragraph.S>Subtotal dos produtos avulsos (1 itens):</Typography.Paragraph.S>
					<Typography.Label.S>{currentValue.toCurrency()}</Typography.Label.S>
				</Flex>
			</Flex>
		</Flex>
	);
}
